import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { CommonService } from "../service/common.service";
import { YoyakuService } from "../service/yoyaku.service";
import { ShareService } from "../service/share.service";
import { UsersService } from "../service/users.service";

import { Mode } from "../app.constant";

declare var $;

@Component({
  selector: "app-b0202-yoyaku",
  templateUrl: "./b0202-yoyaku.component.html",
  styleUrls: ["./b0202-yoyaku.component.css"],
})
export class B0202YoyakuComponent implements OnInit {
  yoyakuInfo: any = null;
  yoyakuhyoInfo: any = null;
  yoyakuhyoDetail: any = null;
  scroll_table: boolean = true;   
  mode: number;
  MODE: any = Mode;

  userInfo: any;

  selected_division_id: any;
  divisionList: any = null;
  timeaxisList: any = null;
  dateList: any = null;
  yoyakuList: any = null;
  myYoyaku: any = null;

  //componet間共有のため
  constructor(
    private commonService: CommonService,
    private usersService: UsersService,
    private yoyakuService: YoyakuService,
    private router: Router,
    private shareService: ShareService,
    private location: Location
  ) {}

  ngOnInit() {
// ブラウザ判定
    var userAgent = this.commonService.getUserAgent();
    if (userAgent == "Internet Explorer") {
      console.log("IE");
      this.scroll_table = false;
    } else if (userAgent == "Edge") {
      console.log("Edge");
      this.scroll_table = false;
    } else if (userAgent == "FireFox") {
      console.log("FireFox");
      this.scroll_table = true;
    } else {
      console.log("another");
      this.scroll_table = true;
    }
    //component読み込みのため、スクロール位置を固定で一番上に
    window.scrollTo(0, 0);

    this.userInfo = this.usersService.userinfo;

    //予約情報を取得
    this.yoyakuInfo = this.shareService.getCategoryInfoShare();
    this.mode = this.shareService.getModeShare();

    if (this.yoyakuInfo == null) {
      this.commonService.modalOpens(90001, (modalresult) => {
        this.router.navigate(["/home"]);
      });
    }
    let params = {
      t_person_id: this.yoyakuInfo["t_person_id"],
      t_yoyakuhyo_id: this.yoyakuInfo["t_yoyakuhyo_id"],
      m_language_id: this.yoyakuInfo["m_language_id"],
      m_division_1_id: this.yoyakuInfo["m_division_1_id"],
      m_division_2_id: this.yoyakuInfo["m_division_2_id"],
    };
    //ポイントによる○×制御があるため、常に取り直す
    this.getYoyakuCalenderList(params);
  }

  getYoyakuCalenderList(params): void {
    this.yoyakuService.getYoyakuCalenderList(params).subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          //yoyakuCalenderListが0レコードならエラー⇒画面側に表示
          this.yoyakuhyoInfo = res["fuel_results"]["yoyakuhyoInfo"];

          this.yoyakuhyoDetail = this.yoyakuhyoInfo.yoyakuhyoDetail[0];
          //縦軸
          this.dateList = res["fuel_results"]["dateList"];
          //横軸
          this.timeaxisList = this.yoyakuhyoInfo.timeaxisList;
          //セレクトボックス
          this.divisionList = this.yoyakuhyoInfo.divisionList;

          if (params.m_division_1_id == 0 && params.m_division_2_id == 0) {
            this.selected_division_id = this.divisionList[0]["m_division_id"];
          } else {
            this.selected_division_id =
              params.m_division_1_id + "_" + params.m_division_2_id;
          }

          //予約内容
          this.yoyakuList = res["fuel_results"]["yoyakuList"];
          if (res["fuel_results"]["myYoyaku"].length > 0) {
            this.myYoyaku = res["fuel_results"]["myYoyaku"][0];
          }
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {}
          );
        } else {
          var page_url = location.href;
          var match = page_url.includes("wellnessSupportToolsSec");
          if (match) {
            this.commonService.modalOpens(11013, (modalresult) => {
              this.router.navigate(["/signin/"]);
            });
          } else {
            this.commonService.modalOpens(11003, (modalresult) => {});
          }
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
      }
    );
  }

  changeDivision(selected_division_id): void {
    //selected_division_idを分解
    var tempdiv = [];
    //～でsplit
    tempdiv = selected_division_id.split("_");

    let params = {
      t_person_id: this.yoyakuInfo["t_person_id"],
      t_yoyakuhyo_id: this.yoyakuInfo["t_yoyakuhyo_id"],
      m_language_id: this.yoyakuInfo["m_language_id"],
      m_division_1_id: tempdiv[0],
      m_division_2_id: tempdiv[1],
    };
    //ポイントによる○×制御があるため、常に取り直す
    this.getYoyakuCalenderList(params);
  }

  /**
   * 確認画面に遷移する
   * @param newYoyaku
   */
  onSelect(newYoyaku) {
    let resultList = {
      yoyaku_info: this.yoyakuInfo,
      new_yoyaku: newYoyaku,
      old_yoyaku: this.myYoyaku,
    };
    this.shareService.setResultListShare(resultList);
    //メインの質問画面に遷移
    this.router.navigate(["/yoyaku/confirm"]);
  }

  goBack(): void {
    this.location.back();
  }

  selectP(p: string): void {
    //1桁目がマイナスの場合、または日付の最終ﾚｺｰﾄﾞを超える場合、移動なし
    if (Number(p) < 0 || Number(p) > this.dateList.length - 1) {
      return;
    }
    $("html,body").animate({ scrollTop: $(`#yid${p}`).offset().top });
  }
}



// WEBPACK FOOTER //
// ./src/app/b0202-yoyaku/b0202-yoyaku.component.ts